@if (isLoading) {
  <div class="xi-loader-container__inline-overlay">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t; read: 'configurations.activity-table'">
  @if (!isLoading) {
    <div class="configuration-activity-table__tables-wrapper">
      <div class="xi-table__header configuration-activity-table__header">
        <h3 class="kxi-text-600 kxi-text-normal">{{ t('auto-analysis') }}</h3>
      </div>
      <table
        mat-table
        [dataSource]="autoAnalysisTableData"
        matSort
        matSortActive="name"
        matSortDirection="asc"
        matSortDisableClear
        (matSortChange)="onAutoAnalysisTableSortChanged($event)"
        class="xi-table__table"
      >
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="xi-table__header-sort-container"
          >
            <div class="xi-table__table-header-content">
              <div class="xi-table__table-header-border"></div>
              <span>{{ t('name') }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.analysisName }}</td>
        </ng-container>
        <ng-container matColumnDef="project">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="xi-table__header-sort-container"
          >
            <div class="xi-table__table-header-content">
              <div class="xi-table__table-header-border"></div>
              <span>{{ t('project') }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.projectName }}</td>
        </ng-container>
        <ng-container matColumnDef="collection">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="xi-table__header-sort-container"
          >
            <div class="xi-table__table-header-content">
              <div class="xi-table__table-header-border"></div>
              <span>{{ t('collection') }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.collectionName }}</td>
        </ng-container>
        <ng-container matColumnDef="docs">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="xi-table__header-sort-container"
          >
            <div class="xi-table__table-header-content">
              <div class="xi-table__table-header-border"></div>
              <span>{{ t('docs') }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.documentCount }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="autoAnalysisTableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: autoAnalysisTableColumns"></tr>
        <tr *matNoDataRow>
          <ng-container
            *ngTemplateOutlet="tNoResults; context: { columns: autoAnalysisTableColumns }"
          ></ng-container>
        </tr>
      </table>
      <div class="configuration-activity-table__table-container">
        <div class="xi-table__header configuration-activity-table__header">
          <h3 class="kxi-text-600 kxi-text-normal">{{ t('layered-configuration') }}</h3>
        </div>
        <table
          mat-table
          [dataSource]="layeredConfigTableData"
          matSort
          matSortActive="name"
          matSortDirection="asc"
          matSortDisableClear
          (matSortChange)="onLayeredConfigTableSortChanged($event)"
          class="xi-table__table"
        >
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="xi-table__header-sort-container"
            >
              <div class="xi-table__table-header-content">
                <div class="xi-table__table-header-border"></div>
                <span>{{ t('name') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.layeredConfigName }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="layeredConfigTableColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: layeredConfigTableColumns"></tr>
          <tr *matNoDataRow>
            <ng-container
              *ngTemplateOutlet="tNoResults; context: { columns: layeredConfigTableColumns }"
            ></ng-container>
          </tr>
        </table>
      </div>
      <div class="configuration-activity-table__table-container">
        <div class="xi-table__header configuration-activity-table__header">
          <h3 class="kxi-text-600 kxi-text-normal">{{ t('configuration-route') }}</h3>
        </div>
        <table
          mat-table
          [dataSource]="configRouteTableData"
          matSort
          matSortActive="name"
          matSortDirection="asc"
          matSortDisableClear
          (matSortChange)="onConfigRouteTableSortChanged($event)"
          class="xi-table__table"
        >
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="xi-table__header-sort-container"
            >
              <div class="xi-table__table-header-content">
                <div class="xi-table__table-header-border"></div>
                <span>{{ t('name') }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.config_route_name }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="configRouteTableColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: configRouteTableColumns"></tr>
          <tr *matNoDataRow>
            <ng-container
              *ngTemplateOutlet="tNoResults; context: { columns: configRouteTableColumns }"
            ></ng-container>
          </tr>
        </table>
      </div>
    </div>
    <ng-template #tNoResults let-columns="columns">
      <td class="mat-cell" [attr.colspan]="columns?.length">
        <div>
          <p class="configuration-activity-table__no-results-text">{{ t('not-in-use') }}</p>
        </div>
      </td>
    </ng-template>
  }
</ng-container>
